import React, { Component } from "react";
import NaviManu from "../NaviManu";
import HomeContainer from "./HomeContainer";
import ScrollProgress from "../common/ScrollProgress";
import BackToTop from "../common/BackToTop";
// import ThemeToggle from "../common/ThemeToggle";
import Footer from "../common/Footer";

export default class HomePage extends Component {
  render() {
    return (
      <div>
        <ScrollProgress />
        {/* <ThemeToggle /> */}
        <NaviManu />
        <HomeContainer />
        <Footer />
        <BackToTop />
      </div>
    );
  }
}
